import { useEffect } from "react";

const useCallbackWithCondition = (value, invalidValue, cb) => {
  useEffect(() => {
    if (value !== invalidValue) cb(value);
  }, [cb, invalidValue, value]);
};

export default useCallbackWithCondition;
